import type { BackendFolderNode, FolderInTree } from './types'

/**
 * Serializes a folder tree from the backend format to the frontend format. The
 * input must already be in the correct tree structure - this function does not
 * match nodes with their parents and assumes that the input is already structured
 * correctly.
 */
export const serializeFolder = (node: BackendFolderNode): FolderInTree => ({
  children: node.children.map(serializeFolder),
  id: node.folder.id,
  name: node.folder.name,
  nodeType: 'folder',
})
